<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <div class="overline primary--text pr-1 text-left">
          {{ $t("formula.template.tableHeader") }}
        </div>
        <v-data-table
          :headers="headers"
          :items="formulaTemplates"
          :items-per-page="10"
          class="elevation-1"
        >
          <template v-slot:header.action="{ props }">
            <v-tooltip bottom v-if="permitted('Formula.Create')">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  x-small
                  color="accent"
                  @click="editTemplate(null)"
                  v-on="on"
                >
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("formula.tooltips.newTemplate") }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.awaitAllInput="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" dark v-bind="attrs" v-on="on">
                  {{ item.awaitAllInput ? "mdi-clock-in" : "mdi-share-all" }}
                </v-icon>
              </template>
              <span>{{
                item.awaitAllInput
                  ? $t("formula.tooltips.awaiting")
                  : $t("formula.tooltips.notAwaiting")
              }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.updatedAt="{ item }">
            {{
              humanDate(item.updatedAt) != "N/A"
                ? humanDate(item.updatedAt)
                : humanDate(item.createdAt)
            }}
          </template>

          <template v-slot:item.action="{ item }">
            <v-icon
              v-if="permitted('Formula.Update') && owns(item.companyId)"
              @click="editTemplate(item.formulaTemplateId)"
              class="mr-2"
              color="primary"
            >
              mdi-pencil
            </v-icon>

            <v-icon
              v-if="permitted('Formula.Delete') && owns(item.companyId)"
              dark
              color="error"
              @click="openConfirm(item.formulaTemplateId)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
      <delete-dialog
        :dialog="confirmDelete"
        v-on:confirm-delete="removeTemplate"
        v-on:cancel-dialog="confirmDelete = false"
      />
      <v-dialog v-model="dialog" min-width="86vh" max-width="90vh">
        <create-formula-template-form
          :formulaTemplateId="currentId"
          @update="reload"
        />
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import DeleteDialog from "@/components/common/DeleteDialog";
import CreateFormulaTemplateForm from "./CreateFormulaTemplateForm.vue";

export default {
  name: "FormulaTemplateList",

  data() {
    return {
      confirmDelete: false,
      currentId: null,
      dialog: false,

      headers: [
        { text: this.$t("formula.fields.name"), value: "name" },
        {
          text: this.$t("formula.fields.awaitAllInput"),
          value: "awaitAllInput",
        },
        {
          text: this.$t("formula.fields.isGlobal"),
          value: "isGlobal",
        },
        {
          text: this.$t("formula.fields.formula"),
          value: "value",
        },
        {
          text: this.$t("formula.fields.description"),
          value: "description",
        },
        { text: this.$t("formula.fields.updatedAt"), value: "updatedAt" },
        { text: "", value: "action", sortable: false },
      ],
    };
  },

  computed: {
    ...mapState("formulas", ["formulaTemplates"]),
  },
  methods: {
    ...mapActions("formulas", ["getFormulaTemplates", "deleteFormulaTemplate"]),

    editTemplate(id) {
      this.currentId = id;
      this.dialog = true;
    },

    async reload() {
      await this.getFormulaTemplates();
      this.dialog = false;
    },

    async removeTemplate() {
      if (this.currentId == null || this.currentId == undefined) {
        this.error(this.$t("formula.errors.noId"));
        return;
      }

      if (!(await this.deleteFormulaTemplate(this.currentId)))
        this.error(this.$t("formula.errors.delete"));
      this.confirmDelete = false;
      await this.reload();
    },

    openConfirm(id) {
      this.currentId = id;
      this.confirmDelete = true;
    },
  },

  async created() {
    await this.getFormulaTemplates();
  },

  components: {
    DeleteDialog,
    CreateFormulaTemplateForm,
  },
};
</script>
